class ASMobileSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.track = this.querySelector('[data-as-slider-track]');
    this.slides = [...this.querySelectorAll('[data-as-slider-slide]')];
    this.dots = [...this.querySelectorAll('[data-as-slider-dot]')];
    this.pageStarts = this.dots.map((dot, index) => Number.parseInt(dot.dataset.asSliderIndex || String(index), 10));
    if (!this.track || this.slides.length < 2) return;

    this.querySelector('[data-as-slider-previous]')?.addEventListener('click', () => this.move(-1));
    this.querySelector('[data-as-slider-next]')?.addEventListener('click', () => this.move(1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(this.pageStarts[index] || 0)));
    this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
  }

  queueUpdate() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => this.update());
  }

  getIndex() {
    const center = this.track.scrollLeft + this.track.clientWidth / 2;
    return this.slides.reduce((closest, slide, index) => {
      const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      return Math.abs(slideCenter - center) < closest.distance
        ? { index, distance: Math.abs(slideCenter - center) }
        : closest;
    }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
  }

  getPageIndex() {
    const currentScroll = this.track.scrollLeft;
    return this.pageStarts.reduce((closest, slideIndex, pageIndex) => {
      const slide = this.slides[slideIndex];
      if (!slide) return closest;
      const targetScroll = slide.offsetLeft - this.track.offsetLeft;
      const distance = Math.abs(targetScroll - currentScroll);
      return distance < closest.distance ? { index: pageIndex, distance } : closest;
    }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
  }

  move(direction) {
    const currentPage = this.getPageIndex();
    const nextPage = Math.max(0, Math.min(this.pageStarts.length - 1, currentPage + direction));
    this.goTo(this.pageStarts[nextPage] || 0);
  }

  goTo(index) {
    const slide = this.slides[index];
    if (!slide) return;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
  }

  update() {
    const pageIndex = this.getPageIndex();
    this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === pageIndex ? 'true' : 'false'));
    const previous = this.querySelector('[data-as-slider-previous]');
    const next = this.querySelector('[data-as-slider-next]');
    if (previous) previous.disabled = pageIndex === 0;
    if (next) next.disabled = pageIndex === this.pageStarts.length - 1;
  }
}

if (!customElements.get('as-mobile-slider')) {
  customElements.define('as-mobile-slider', ASMobileSlider);
}
